import { employeeSkills } from '../employeeSkill'
import { describeTable } from './describeTable'

describeTable(employeeSkills, {
  description:
    'Junction between employees and skills with a proficiency level. HR profile data maintained in the ERP; not used by booking, capacity or revenue logic. No soft-delete column — a removed skill is deleted outright.',
  columns: {
    level: 'beginner / intermediate / expert, as assessed by the office.',
  },
})
